import { NgClass } from '@angular/common';
import { Component, Input, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-card',
  templateUrl: './card.component.html',
  styleUrls: ['./card.component.scss'],
  encapsulation: ViewEncapsulation.None,
  imports: [NgClass],
})
export class CardComponent {
  @Input() public title: string;
  @Input() public headerClasses: string | string[] | Set<string> | { [klass: string]: any } = '';
  @Input() public contentClasses: string | string[] | Set<string> | { [klass: string]: any } = '';
}
